import { AxiosInstance } from 'axios'
import { ApprovalApi } from './approval'
import { AreaApi } from './area'
import { AuditLogApi } from './audit-log'
import { AuthApi } from './auth'
import { DepartmentApi } from './categories/department'
import { MasterTypeApi } from './categories/master-type'
import { CustomFieldApi } from './custom-field'
import { CustomFieldValueApi } from './custom-field-value'
import { MasterDataApi } from './master-data'
import { PermissionApi } from './permission'
import { ProjectApi } from './project'
import { RegionApi } from './region'
import { RoleApi } from './role'
import { ProjectTemplateApi } from './template'
import { UserApi } from './user'
import { DocumentApi } from './document'
import { FolderApi } from './folder'
import { TaskApi } from './task'
import { ProjectPermissionApi } from './project-permission'
import { ResourceShareApi } from './resource-share'
import { AttachmentApi } from './attachment'
import { RequestApprovalApi } from './request-approval'
import { GlobalSearchApi } from './search'
import { NotificationApi } from './notification'
import { StatusHistoryApi } from './status-history'

// Re-export all types from domain modules
export * from './audit-log'
export * from './auth'
export * from './base.type'
export * from './custom-field'
export * from './custom-field-value'
export * from './master-data'
export * from './permission'
export * from './project'
export * from './role'
export * from './template'
export * from './user'
export * from './task'
export * from './document'
export * from './department'
export * from './project-permission'
export * from './approval'
export * from './request-approval'
export * from './status-history'

export * from './resource-share'
export * from './attachment'
export * from './search'
export * from './notification'
/**
 * API class for the application
 * @example
 * const api = new Api(
 * axios.create({
        baseURL: 'http://localhost:8080',
    }),
 * )
 * api.auth.login({ email, password })
 */
export class Api {
    auth: AuthApi
    auditLog: AuditLogApi
    permission: PermissionApi
    projectTemplate: ProjectTemplateApi
    role: RoleApi
    user: UserApi
    region: RegionApi
    area: AreaApi
    department: DepartmentApi
    project: ProjectApi
    masterData: MasterDataApi
    customField: CustomFieldApi
    customFieldValue: CustomFieldValueApi
    masterType: MasterTypeApi
    document: DocumentApi
    folder: FolderApi
    task: TaskApi
    projectPermission: ProjectPermissionApi
    approval: ApprovalApi
    resourceShare: ResourceShareApi
    attachment: AttachmentApi
    requestApproval: RequestApprovalApi
    searchGlobal: GlobalSearchApi
    notification: NotificationApi
    statusHistory: StatusHistoryApi

    constructor(private readonly client: AxiosInstance) {
        this.auth = new AuthApi(this.client)
        this.auditLog = new AuditLogApi(this.client)
        this.permission = new PermissionApi(this.client)
        this.projectTemplate = new ProjectTemplateApi(this.client)
        this.project = new ProjectApi(this.client)
        this.role = new RoleApi(this.client)
        this.user = new UserApi(this.client)
        this.region = new RegionApi(this.client)
        this.area = new AreaApi(this.client)
        this.department = new DepartmentApi(this.client)
        this.masterData = new MasterDataApi(this.client)
        this.customField = new CustomFieldApi(this.client)
        this.customFieldValue = new CustomFieldValueApi(this.client)
        this.masterType = new MasterTypeApi(this.client)
        this.document = new DocumentApi(this.client)
        this.folder = new FolderApi(this.client)
        this.task = new TaskApi(this.client)
        this.projectPermission = new ProjectPermissionApi(this.client)
        this.approval = new ApprovalApi(this.client)
        this.resourceShare = new ResourceShareApi(this.client)
        this.attachment = new AttachmentApi(this.client)
        this.requestApproval = new RequestApprovalApi(this.client)
        this.searchGlobal = new GlobalSearchApi(this.client)
        this.notification = new NotificationApi(this.client)
        this.statusHistory = new StatusHistoryApi(this.client)
    }
}
